<!-- 学员年龄 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector
      v-bind="config"
      v-model="studentAge"
      type="studentAge"
      ref="child"
      clearable
    />
  </el-form-item>
</template>

<script>
import { inject, ref } from 'vue';

export default {
  kind: 'yq-学员年龄选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ({
        min: '',
        max: '',
      }),
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    label: {
      type: String,
      default: '学员年龄：',
    },
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');
    const studentAge = useQuery('studentAge', props.value, () => child.value.resetAge());

    return {
      studentAge,
      child,
    };
  },
};
</script>
